import type { ComponentStyleConfig } from "@chakra-ui/react";

import { inputSizeOverrides } from "../shared-themes";

export const NumberInputTheme: ComponentStyleConfig = {
  baseStyle: {
    field: {
      _focusVisible: {
        _focusVisible: {
          borderColor: "brand.red.100",
          boxShadow: `0px 0px 0px 1px var(--chakra-colors-brand-red-100)`,
        },
      },
      "&:not(:placeholder-shown)": {
        bg: "transparent",
        // border: "none",
      },
      "&.hide-border": {
        bg: "transparent",
        border: "none",
      },
    },
  },
  variants: {
    outline: {
      field: {
        bg: "white",
        border: "1px solid",
        borderColor: "brand.gray.110",
        _hover: {
          borderColor: "brand.black.90",
        },
        _disabled: {
          backgroundColor: "gray.300",
        },
      },
      _focusVisible: {
        borderColor: "brand.red.100",
        boxShadow: `0px 1px 0px 1px var(--chakra-colors-brand-red-100)`,
      },
    },
  },
  sizes: inputSizeOverrides,
};
